const PLATING_ACTION_TYPES = {
  LOAD_PLATING: 'plating/LOAD_PLATING',
};

export default PLATING_ACTION_TYPES;
